import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { LoginPageComponent } from './login-page/login-page.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { SplashPageRoutingModule } from './splash-routing.module';
import { MaterialModule } from '@huge-monorepo/shared/modules';
import { ToolsModule } from '@huge-monorepo/shared/tools';
import { MatColComponent } from '@huge-monorepo/shared/tools';
import { MatRowComponent } from '@huge-monorepo/shared/tools';

@NgModule({
  imports: [CommonModule, SplashPageRoutingModule, FormsModule, ReactiveFormsModule, MaterialModule, ToolsModule, MatColComponent, MatRowComponent],
  declarations: [ForgotPasswordComponent, ResetPasswordComponent, LoginPageComponent],
  providers: [],
})
export class SplashPageModule {}

